<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6 font-weight-regular">
        {{ $t('APPS.ITEMS') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <apps-list :items="items" @edit="edit" />

        <v-dialog
          v-if="dialog"
          v-model="dialog"
          persistent
          width="unset"
          max-width="600"
        >
          <emails-dialog
            :data="item"
            @created="cancelDialogAndRefresh"
            @updated="cancelDialogAndRefresh"
            @cancel="cancelDialog"
          />
        </v-dialog>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import AppsList from '@/modules/forms/components/AppsList.vue';
import { mapActions } from 'vuex';
import EmailsDialog from '@/modules/forms/components/EmailsDialog.vue';

export default {
  name: 'FormAppsList',
  components: { EmailsDialog, AppsList },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    items: [],
    item: null,
    dialog: false
  }),

  created() {
    this.refreshData();
  },

  methods: {
    ...mapActions('form', ['retrieveFormApps']),
    refreshData() {
      this.retrieveFormApps(this.id)
        .then(({ data }) => {
          this.items = data.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },

    edit(item) {
      this.dialog = true;
      this.item = { ...item };
    },

    cancelDialog() {
      this.dialog = false;
      this.item = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    }
  }
};
</script>
<style scoped></style>
